<template>
    <div class="lms__superadmin_customer_edit_emailsenders">
        <component-text
            :html="true"
            :is-slot="true"
        >The email address currently used for sending is: <strong>{{ defaultSenderEmailAddress }}</strong></component-text>
        <component-list
            :component-table="LmsSuperadminCustomerEditEmailSendersTable"
            :component-table-add-active="addEmailSenderFormActive"
            :component-table-name="'senders'"
            :get-items-getter="'getLmsSuperadminCustomerEmailSenders'"
            :get-items-dispatch="'lmsSuperadminCustomerEmailSendersGet'"
            :get-items-dispatch-params="{ customerId }"
            :item-name="['sender', 'senders']"
            :filter-actions-active="true"
            :filter-actions-primary-button-text="'Add sender'"
            :filter-actions-primary-button-active="true"
            :filter-actions-primary-button-disabled="addEmailSenderFormActive"
            @emit-actions-primary="openAddEmailSenderForm"
            @emit-request-finally="closeAddEmailSenderForm"
        ></component-list>
    </div>
</template>

<script>

import ComponentText from '@/components/default/shared/ComponentText'
import ComponentList from '@/components/default/shared/ComponentList'
import LmsSuperadminCustomerEditEmailSendersTable from '@/components/lms/superadmin/customer/edit/LmsSuperadminCustomerEditEmailSendersTable'
import { validateBeforeRouteLeave } from '@/helpers/mixins'

export default {
  name: 'lms-superadmin-customer-edit-email-senders',
  mixins: [validateBeforeRouteLeave],
  components: { ComponentList, ComponentText },
  data () {
    return {
      LmsSuperadminCustomerEditEmailSendersTable,
      addEmailSenderFormActive: false
    }
  },
  computed: {
    customerId () {
      return this.$route.params.id
    },
    defaultSender () {
      return this.$store.getters.getLmsSuperadminCustomerEmailSendersDefault
    },
    defaultSenderEmailAddress () {
      return this.defaultSender ? this.defaultSender.emailAddress : undefined
    }
  },
  methods: {
    openAddEmailSenderForm () {
      this.addEmailSenderFormActive = true
    },
    closeAddEmailSenderForm () {
      this.addEmailSenderFormActive = false
    }
  },
  mounted () {
    this.$eventBus.$on('close-email-sender-field', this.closeAddEmailSenderForm)
  },
  beforeDestroy () {
    this.$eventBus.$off('close-email-sender-field')
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/customers/_lmssuperadmincustomeraddeditemailsenders.scss";
</style>
